class ClientType {
  findAll () {
    const data = {
      clientType:
        [
          {
            text: 'HMG',
            value: 'HMG'
          },
          {
            text: 'PRD',
            value: 'PRD'
          }
        ]
    }
    return data.clientType
  }
}

export default new ClientType()
